<template>
  <v-card>
    <v-card-title>{{ shouldUpdate ? `Обновить кросс-сейл` : `Добавить кросс-сейл` }}</v-card-title>
    <v-card-text>
      <IngredientCell
        :item="selectedIngredient"
        @click="itemSelect" />
      <v-text-field
        v-model.number="priority"
        type="number"
        outlined
        hide-details
        dense
        label="Приоритет"
        class="mt-4" />
      <v-dialog
        v-model="ingredientsSelectionDialog"
        max-width="700"
      >
        <IngredientsSelectionDialog
          @select="select"
          :selectedIngredients="selectedIngredients"
        /> </v-dialog
    ></v-card-text>
    <v-card-actions>
      <v-row
        class="ma-0"
        justify="center"
        no-gutters
      >
        <v-btn
          :color="'primary'"
          depressed
          @click="confirm"
          class="mr-3"
          :loading="loading"
          :disabled="!selectedIngredient"
          >{{ shouldUpdate ? 'Обновить' : 'Добавить' }}
        </v-btn>
        <v-btn
          v-if="shouldUpdate"
          class="white--text"
          depressed
          color="red"
          @click="removeDialog = true"
          :disabled="loading"
          >{{ 'Удалить' }}
        </v-btn>
        <v-btn
          depressed
          color=""
          @click="close"
          class="ml-3"
          :disabled="loading"
        >
          Отменить
        </v-btn>
      </v-row>
    </v-card-actions>
    <!-- Диалог удаления -->
    <v-dialog
      v-model="removeDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title>Удалить</v-card-title>
        <v-card-text>Удалить выбранный кросс-сейл?</v-card-text>
        <v-card-actions>
          <v-btn
            v-if="shouldUpdate"
            class="white--text"
            depressed
            color="primary"
            @click="remove"
            >{{ 'Удалить' }}
          </v-btn>
          <v-btn
            depressed
            color=""
            @click="removeDialog = false"
            class="ml-3"
          >
            Отменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import IngredientsSelectionDialog from './ingredientSelection/IngredientsSelectionDialog.vue'
  import IngredientCell from './ingredientSelection/IngredientCell.vue'
  import { CrossSell } from '@/models/crossseil.js'

  export default {
    name: 'CrossSellDialogItem',
    components: { IngredientsSelectionDialog, IngredientCell },
    props: {
      selectedIngredients: [],
      item: {
        type: Object,
        required: false
      }
    },
    data: () => ({
      shouldUpdate: false,
      crossSellItem: null,
      selectedIngredient: null,
      ingredientsSelectionDialog: false,
      removeDialog: false,
      priority: 100,
      loading: false,
      crossSell: new CrossSell()
    }),
    methods: {
      itemSelect() {
        this.ingredientsSelectionDialog = true
      },
      select(value) {
        console.log(value)
        this.ingredientsSelectionDialog = false
        this.selectedIngredient = value
      },
      clear() {
        this.selectedIngredient = null
        this.priority = 100
      },
      close() {
        this.clear()
        this.$emit('close')
      },
      remove() {
        if (this.shouldUpdate) {
          this.removeDialog = false
          this.loading = true

          this.crossSell
            .destroy(this.item.id)
            .then(() => {
              this.dialog = false
              this.$emit('remove', this.item)
              this.close()
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      confirm() {
        if (this.shouldUpdate) {
          this.update()
        } else {
          this.create()
        }
      },
      update() {
        const item = {
          ...this.item,
          ingredient: this.selectedIngredient.id,
          priority: this.priority
        }

        this.loading = true
        this.crossSell
          .update(item)
          .then(v => {
            this.$emit('update', v)
            this.close()
          })
          .finally(() => {
            this.loading = false
          })
      },
      create() {
        const item = {
          group: this.$productGroup.item.id,
          ingredient: this.selectedIngredient.id,
          priority: this.priority,
          active: true
        }

        this.loading = true
        this.crossSell
          .create(item)
          .then(v => {
            this.$emit('added', v)
            this.close()
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    mounted() {
      if (this.item != null) {
        this.selectedIngredient = this.item.ingredient
        this.priority = this.item.priority
        this.shouldUpdate = true
      }
    }
  }
</script>
